/**
 * Global application constants
 */
export const APPLICATION_NAME = "Single Skill Database";

export const API_STALE_TIME = {
	THIRTY_SECONDS: 30000,
	ZERO_SECONDS: 0,
};

export const API_CACHE_TIME = {
	ZERO_SECONDS: 0,
};

export const MAX_FILE_SIZE_MB = 1 * 1024 * 1024;

export const ALLOWED_FILES = ".pdf, .csv, .doc, .docx, .jpg, .jpeg, .png";

export const MAX_FILE_SIZE_TITLE = "1MB";

export const MAX_PAGES_TO_SHOW_FOR_PAGINATION = 5;

export const LANGUAGES_KEYS = {
	en: "en",
	ur: "ur",
};

export const LANGUAGES_VALUES = {
	en: "🇺🇸 English",
	ur: "🇵🇰 اردو",
};

export const LANGUAGES = {
	english: "English",
	urdu: "Urdu",
};

export const MODAL_KEYS = {
	CHALLAN_CUSTOMIZE: "customizeChallan",
	INSTITUTE_DETAILS: "instituteDetailsModal",
	ADD_EQUIPMENT: "addEquipmentModal",
	ADD_LAB: "addLabModal",
	ADD_MEMEBRS: "addMemberModal",
	COMMITTEE_DETAILS: "committeeDetailsModal",
	CONSTITUTE_COMMITTEE: "constituteCommitteeModal",
} as const;

export const COMMITTEE_MODAL_STEPS = {
	APPLIED_COURSE_DETAILS: "appliedCourseDetails",
	CONSTITUTED_COMMITTEE: "constitutedCommittee",
	COMMITTEE_MEMBERS: "committeeMembers",
	APPROVAL_SENT: "approvalSent",
} as const;

export const EXPORT_OPTIONS = [
	{ value: "csv", label: "CSV" },
	{ value: "pdf", label: "PDF" },
	{ value: "excel", label: "Excel" },
];

// Inspection Theme Colors (Green theme)
export const INSPECTION_COLORS = {
	PRIMARY: "#10B981", // Green-500
	SECONDARY: "#059669", // Green-600
	SUCCESS: "#10B981", // Green-500
	ERROR: "#EF4444", // Red-500
	WARNING: "#F59E0B", // Amber-500
	INFO: "#3B82F6", // Blue-500
	LIGHT: "#D1FAE5", // Green-100
	DARK: "#047857", // Green-700
} as const;

// Inspection Equipment Constants
export const EQUIPMENT_STATUS = {
	PENDING: "pending",
	ACCEPT: "accept",
	REJECT: "reject",
} as const;
